var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "full-height",
      attrs: { id: "app" },
      on: { click: _vm.setTimerData },
    },
    [
      _c("b-overlay", {
        staticClass: "full-height",
        attrs: {
          fixed: "",
          "no-wrap": "",
          "spinner-variant": "primary",
          show: _vm.isLoading,
          variant: _vm.variant,
          opacity: _vm.opacity,
          blur: _vm.blur,
          "z-index": "1500",
          rounded: "sm",
        },
      }),
      _vm.isAuthenticated && !_vm.isRouteSelectOrganisation
        ? _c("NavBar", {
            key: _vm.navbarComponentKey,
            on: {
              kioskMode: function ($event) {
                return _vm.kioskMode()
              },
            },
          })
        : _vm._e(),
      _c("KioskMode", {
        key: _vm.uuid + "" + _vm.enableKioskMode,
        ref: "kioskmode",
        attrs: { uuid: _vm.uuid, cliniciansdata: _vm.cliniciansdata },
      }),
      _c(
        "b-container",
        { attrs: { fluid: "" } },
        [_c("router-view", { key: _vm.$route.fullPath })],
        1
      ),
      _c(
        "b-modal",
        _vm._b(
          {
            attrs: {
              id: "errorModal",
              title: _vm.timeouterror.title,
              "ok-title": "Close",
              "ok-only": "",
            },
            on: { hidden: _vm.closeModal },
            model: {
              value: _vm.timeouterror.isOpen,
              callback: function ($$v) {
                _vm.$set(_vm.timeouterror, "isOpen", $$v)
              },
              expression: "timeouterror.isOpen",
            },
          },
          "b-modal",
          _vm.$attrs,
          false
        ),
        [_vm._v(" " + _vm._s(_vm.timeouterror.message) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }